
import { WorldCity } from '../types';

// Expansión de ciudades adicionales para Estados Unidos (de 100 a 300 ciudades)
export const unitedStatesAdditionalCities: WorldCity[] = [
  // Ciudades adicionales 101-200
  { name: 'Spokane', slug: 'spokane', population: 230176 },
  { name: 'Baton Rouge', slug: 'baton-rouge', population: 227470 },
  { name: 'Des Moines', slug: 'des-moines', population: 215472 },
  { name: 'Tacoma', slug: 'tacoma', population: 219346 },
  { name: 'Rochester', slug: 'rochester-ny', population: 206284 },
  { name: 'Modesto', slug: 'modesto', population: 218464 },
  { name: 'Oxnard', slug: 'oxnard', population: 207906 },
  { name: 'Fontana', slug: 'fontana', population: 208393 },
  { name: 'Moreno Valley', slug: 'moreno-valley', population: 208634 },
  { name: 'Huntington Beach', slug: 'huntington-beach', population: 198711 },
  { name: 'Glendale', slug: 'glendale-ca', population: 196543 },
  { name: 'Santa Clarita', slug: 'santa-clarita', population: 228673 },
  { name: 'Grand Rapids', slug: 'grand-rapids', population: 198917 },
  { name: 'Salt Lake City', slug: 'salt-lake-city', population: 200591 },
  { name: 'Tallahassee', slug: 'tallahassee', population: 194500 },
  { name: 'Worcester', slug: 'worcester', population: 206518 },
  { name: 'Newport News', slug: 'newport-news', population: 186247 },
  { name: 'Huntsville', slug: 'huntsville', population: 215006 },
  { name: 'Knoxville', slug: 'knoxville', population: 190740 },
  { name: 'Providence', slug: 'providence', population: 190934 },
  { name: 'Fort Lauderdale', slug: 'fort-lauderdale', population: 182760 },
  { name: 'Chattanooga', slug: 'chattanooga', population: 181099 },
  { name: 'Tempe', slug: 'tempe', population: 195805 },
  { name: 'Aurora', slug: 'aurora-il', population: 180542 },
  { name: 'Santa Rosa', slug: 'santa-rosa', population: 178127 },
  { name: 'Eugene', slug: 'eugene', population: 176654 },
  { name: 'Pembroke Pines', slug: 'pembroke-pines', population: 171178 },
  { name: 'Salem', slug: 'salem-or', population: 175535 },
  { name: 'Cape Coral', slug: 'cape-coral', population: 194016 },
  { name: 'Peoria', slug: 'peoria-az', population: 190985 },
  { name: 'Sioux Falls', slug: 'sioux-falls', population: 192517 },
  { name: 'Springfield', slug: 'springfield-mo', population: 169176 },
  { name: 'Vancouver', slug: 'vancouver-wa', population: 185648 },
  { name: 'Rockford', slug: 'rockford', population: 148655 },
  { name: 'Lancaster', slug: 'lancaster-ca', population: 173516 },
  { name: 'Rancho Cucamonga', slug: 'rancho-cucamonga', population: 174453 },
  { name: 'Palmdale', slug: 'palmdale', population: 169450 },
  { name: 'Salinas', slug: 'salinas', population: 155662 },
  { name: 'Springfield', slug: 'springfield-ma', population: 155929 },
  { name: 'Pasadena', slug: 'pasadena-tx', population: 151950 },
  { name: 'Hayward', slug: 'hayward', population: 162954 },
  { name: 'Pomona', slug: 'pomona', population: 151713 },
  { name: 'Escondido', slug: 'escondido', population: 151613 },
  { name: 'Sunnyvale', slug: 'sunnyvale', population: 155805 },
  { name: 'Kansas City', slug: 'kansas-city-ks', population: 156607 },
  { name: 'Hollywood', slug: 'hollywood-fl', population: 153067 },
  { name: 'Clarksville', slug: 'clarksville', population: 166722 },
  { name: 'Torrance', slug: 'torrance', population: 147067 },
  { name: 'Lakewood', slug: 'lakewood-co', population: 155984 },
  { name: 'Naperville', slug: 'naperville', population: 148449 },
  { name: 'Syracuse', slug: 'syracuse', population: 148620 },
  { name: 'Mesquite', slug: 'mesquite', population: 150108 },
  { name: 'Dayton', slug: 'dayton', population: 140444 },
  { name: 'Savannah', slug: 'savannah', population: 147780 },
  { name: 'Bridgeport', slug: 'bridgeport', population: 148654 },
  { name: 'Orange', slug: 'orange-ca', population: 139911 },
  { name: 'Cary', slug: 'cary', population: 174721 },
  { name: 'Fullerton', slug: 'fullerton', population: 143617 },
  { name: 'Warren', slug: 'warren-mi', population: 139387 },
  { name: 'McKinney', slug: 'mckinney', population: 199177 },
  { name: 'McAllen', slug: 'mcallen', population: 143268 },
  { name: 'West Valley City', slug: 'west-valley-city', population: 140230 },
  { name: 'Columbia', slug: 'columbia-sc', population: 137300 },
  { name: 'Sterling Heights', slug: 'sterling-heights', population: 134346 },
  { name: 'New Haven', slug: 'new-haven', population: 134023 },
  { name: 'Miramar', slug: 'miramar', population: 140823 },
  { name: 'Waco', slug: 'waco', population: 139236 },
  { name: 'Thousand Oaks', slug: 'thousand-oaks', population: 126966 },
  { name: 'Cedar Rapids', slug: 'cedar-rapids', population: 137710 },
  { name: 'Olathe', slug: 'olathe', population: 140545 },
  { name: 'Elizabeth', slug: 'elizabeth-nj', population: 137298 },
  { name: 'Hartford', slug: 'hartford', population: 121054 },
  { name: 'Stamford', slug: 'stamford', population: 135470 },
  { name: 'Visalia', slug: 'visalia', population: 141384 },
  { name: 'Gainesville', slug: 'gainesville', population: 141085 },
  { name: 'Simi Valley', slug: 'simi-valley', population: 126181 },
  { name: 'Thornton', slug: 'thornton', population: 141867 },
  { name: 'Roseville', slug: 'roseville-ca', population: 147773 },
  { name: 'Coral Springs', slug: 'coral-springs', population: 134394 },
  { name: 'Beaumont', slug: 'beaumont', population: 118296 },
  { name: 'Vallejo', slug: 'vallejo', population: 126090 },
  { name: 'Allentown', slug: 'allentown', population: 125845 },
  { name: 'Norman', slug: 'norman', population: 128026 },
  { name: 'Columbia', slug: 'columbia-mo', population: 126254 },
  { name: 'Fargo', slug: 'fargo', population: 125990 },
  { name: 'Wilmington', slug: 'wilmington-nc', population: 123744 },
  { name: 'Abilene', slug: 'abilene', population: 125182 },
  { name: 'Odessa', slug: 'odessa', population: 123334 },
  { name: 'Arvada', slug: 'arvada', population: 121510 },
  { name: 'Independence', slug: 'independence-mo', population: 123011 },
  { name: 'Elgin', slug: 'elgin', population: 114797 },
  { name: 'Westminster', slug: 'westminster-co', population: 116317 },
  { name: 'Provo', slug: 'provo', population: 117335 },
  { name: 'Peoria', slug: 'peoria-il', population: 113150 },
  { name: 'High Point', slug: 'high-point', population: 114059 },
  { name: 'Antioch', slug: 'antioch', population: 115291 },
  { name: 'Centennial', slug: 'centennial', population: 111331 },
  { name: 'Richardson', slug: 'richardson', population: 119469 },
  { name: 'Murfreesboro', slug: 'murfreesboro', population: 152769 },
  { name: 'Evansville', slug: 'evansville', population: 117298 },
  { name: 'Surprise', slug: 'surprise', population: 143148 },
  { name: 'Denton', slug: 'denton', population: 148059 },
  { name: 'Carrollton', slug: 'carrollton', population: 133168 },
  { name: 'Concord', slug: 'concord-ca', population: 129295 },
  { name: 'Midland', slug: 'midland', population: 146038 },
  { name: 'Charleston', slug: 'charleston-sc', population: 150227 },
  { name: 'Fairfield', slug: 'fairfield-ca', population: 119881 },
  { name: 'Temecula', slug: 'temecula', population: 110003 },
  { name: 'College Station', slug: 'college-station', population: 120511 },
  { name: 'Lewisville', slug: 'lewisville', population: 111822 },
  { name: 'Sandy Springs', slug: 'sandy-springs', population: 108080 },
  { name: 'Frisco', slug: 'frisco', population: 200509 },
  { name: 'Round Rock', slug: 'round-rock', population: 133372 },
  { name: 'Billings', slug: 'billings', population: 119706 },
  
  // Ciudades adicionales 201-300
  { name: 'West Palm Beach', slug: 'west-palm-beach', population: 117415 },
  { name: 'Richmond', slug: 'richmond-ca', population: 110567 },
  { name: 'Pearland', slug: 'pearland', population: 131448 },
  { name: 'Downey', slug: 'downey', population: 111263 },
  { name: 'Miami Gardens', slug: 'miami-gardens', population: 111640 },
  { name: 'Tyler', slug: 'tyler', population: 107405 },
  { name: 'Jurupa Valley', slug: 'jurupa-valley', population: 111398 },
  { name: 'Inglewood', slug: 'inglewood', population: 109398 },
  { name: 'Lakeland', slug: 'lakeland', population: 112641 },
  { name: 'Rialto', slug: 'rialto', population: 104026 },
  { name: 'El Monte', slug: 'el-monte', population: 113475 },
  { name: 'Broken Arrow', slug: 'broken-arrow', population: 113540 },
  { name: 'Hillsboro', slug: 'hillsboro', population: 106447 },
  { name: 'Sandy', slug: 'sandy-ut', population: 95836 },
  { name: 'Woodbury', slug: 'woodbury', population: 75102 },
  { name: 'Menifee', slug: 'menifee', population: 102527 },
  { name: 'Green Bay', slug: 'green-bay', population: 107395 },
  { name: 'Burbank', slug: 'burbank', population: 107337 },
  { name: 'Renton', slug: 'renton', population: 106785 },
  { name: 'West Jordan', slug: 'west-jordan', population: 116961 },
  { name: 'League City', slug: 'league-city', population: 114140 },
  { name: 'El Cajon', slug: 'el-cajon', population: 102401 },
  { name: 'Davie', slug: 'davie', population: 110320 },
  { name: 'Spokane Valley', slug: 'spokane-valley', population: 102976 },
  { name: 'Las Cruces', slug: 'las-cruces', population: 111385 },
  { name: 'Pueblo', slug: 'pueblo', population: 111776 },
  { name: 'South Bend', slug: 'south-bend', population: 103453 },
  { name: 'Pompano Beach', slug: 'pompano-beach', population: 112046 },
  { name: 'Reno', slug: 'reno', population: 264165 },
  { name: 'Allen', slug: 'allen', population: 105623 },
  { name: 'Citrus Heights', slug: 'citrus-heights', population: 87583 },
  { name: 'Tuscaloosa', slug: 'tuscaloosa', population: 101129 },
  { name: 'Sparks', slug: 'sparks', population: 108445 },
  { name: 'Albany', slug: 'albany-ny', population: 96460 },
  { name: 'Yakima', slug: 'yakima', population: 96968 },
  { name: 'San Mateo', slug: 'san-mateo', population: 104570 },
  { name: 'Sugar Land', slug: 'sugar-land', population: 111026 },
  { name: 'Newport Beach', slug: 'newport-beach', population: 85186 },
  { name: 'Norwalk', slug: 'norwalk-ca', population: 102773 },
  { name: 'Bellingham', slug: 'bellingham', population: 91482 },
  { name: 'Everett', slug: 'everett', population: 113801 },
  { name: 'Redding', slug: 'redding', population: 93611 },
  { name: 'Bellflower', slug: 'bellflower', population: 79190 },
  { name: 'Hemet', slug: 'hemet', population: 89833 },
  { name: 'Livermore', slug: 'livermore', population: 90189 },
  { name: 'Boulder', slug: 'boulder', population: 108777 },
  { name: 'Compton', slug: 'compton', population: 95740 },
  { name: 'Bend', slug: 'bend', population: 99178 },
  { name: 'San Rafael', slug: 'san-rafael', population: 61271 },
  { name: 'Racine', slug: 'racine', population: 77816 },
  { name: 'Hamilton', slug: 'hamilton-oh', population: 62082 },
  { name: 'Longmont', slug: 'longmont', population: 98885 },
  { name: 'Warwick', slug: 'warwick', population: 81043 },
  { name: 'Lynn', slug: 'lynn', population: 101253 },
  { name: 'Lowell', slug: 'lowell', population: 115554 },
  { name: 'Brockton', slug: 'brockton', population: 105643 },
  { name: 'Quincy', slug: 'quincy-ma', population: 101636 },
  { name: 'Fall River', slug: 'fall-river', population: 94000 },
  { name: 'New Bedford', slug: 'new-bedford', population: 101079 },
  { name: 'Lawrence', slug: 'lawrence-ma', population: 89143 },
  { name: 'Somerville', slug: 'somerville', population: 81045 },
  { name: 'Cambridge', slug: 'cambridge', population: 118403 },
  { name: 'Newton', slug: 'newton', population: 88322 },
  { name: 'Waltham', slug: 'waltham', population: 65218 },
  { name: 'Medford', slug: 'medford-ma', population: 57341 },
  { name: 'Malden', slug: 'malden', population: 66263 },
  { name: 'Revere', slug: 'revere', population: 62186 },
  { name: 'Peabody', slug: 'peabody', population: 54481 },
  { name: 'Methuen', slug: 'methuen', population: 53059 },
  { name: 'Haverhill', slug: 'haverhill', population: 67787 },
  { name: 'Weymouth', slug: 'weymouth', population: 57213 },
  { name: 'Pittsfield', slug: 'pittsfield', population: 43927 },
  { name: 'Chicopee', slug: 'chicopee', population: 55186 },
  { name: 'Westfield', slug: 'westfield-ma', population: 41094 },
  { name: 'Holyoke', slug: 'holyoke', population: 38238 },
  { name: 'Leominster', slug: 'leominster', population: 41002 },
  { name: 'Fitchburg', slug: 'fitchburg', population: 41946 },
  { name: 'Attleboro', slug: 'attleboro', population: 46461 },
  { name: 'Beverly', slug: 'beverly', population: 42670 },
  { name: 'Salem', slug: 'salem-ma', population: 44480 },
  { name: 'Woburn', slug: 'woburn', population: 40876 },
  { name: 'Gloucester', slug: 'gloucester', population: 30291 },
  { name: 'Newburyport', slug: 'newburyport', population: 18194 },
  { name: 'Marlborough', slug: 'marlborough', population: 41793 },
  { name: 'Chelsea', slug: 'chelsea-ma', population: 40787 },
  { name: 'Everett', slug: 'everett-ma', population: 49075 },
  { name: 'Framingham', slug: 'framingham', population: 72362 },
  { name: 'Watertown', slug: 'watertown-ma', population: 35329 },
  { name: 'Natick', slug: 'natick', population: 37006 },
  { name: 'Franklin', slug: 'franklin-ma', population: 33644 },
  { name: 'Needham', slug: 'needham', population: 31388 },
  { name: 'Dedham', slug: 'dedham', population: 25364 },
  { name: 'Wellesley', slug: 'wellesley', population: 29550 },
  { name: 'Norwood', slug: 'norwood', population: 31611 },
  { name: 'Stoughton', slug: 'stoughton', population: 29281 },
  { name: 'Canton', slug: 'canton-ma', population: 24370 },
  { name: 'Milton', slug: 'milton', population: 28630 },
  { name: 'Randolph', slug: 'randolph', population: 34984 },
  { name: 'Braintree', slug: 'braintree', population: 39143 },
  { name: 'Holbrook', slug: 'holbrook', population: 12333 },
  { name: 'Weymouth', slug: 'south-weymouth', population: 57213 },
  { name: 'Hingham', slug: 'hingham', population: 24284 },
  { name: 'Cohasset', slug: 'cohasset', population: 8018 },
  { name: 'Scituate', slug: 'scituate', population: 19063 },
  { name: 'Marshfield', slug: 'marshfield', population: 25825 },
  { name: 'Duxbury', slug: 'duxbury', population: 16090 },
  { name: 'Kingston', slug: 'kingston-ma', population: 13629 },
  { name: 'Plymouth', slug: 'plymouth-ma', population: 61217 },
  { name: 'Carver', slug: 'carver', population: 11645 },
  { name: 'Wareham', slug: 'wareham', population: 23303 },
  { name: 'Bourne', slug: 'bourne', population: 19754 },
  { name: 'Sandwich', slug: 'sandwich-ma', population: 20259 },
  { name: 'Falmouth', slug: 'falmouth-ma', population: 32517 },
  { name: 'Mashpee', slug: 'mashpee', population: 15060 },
  { name: 'Barnstable', slug: 'barnstable', population: 44641 },
  { name: 'Yarmouth', slug: 'yarmouth-ma', population: 23793 }
];
